const DEFAULT_RECENT_AWB_LIMIT = 6;

export const normalizeAwb = (value: string) => value.trim().toUpperCase();

export const loadRecentAwbs = (
  storageKey: string,
  limit: number = DEFAULT_RECENT_AWB_LIMIT
): string[] => {
  if (typeof window === 'undefined') return [];
  try {
    const stored = window.localStorage.getItem(storageKey);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    if (!Array.isArray(parsed)) return [];

    const normalized = parsed
      .filter((item) => typeof item === 'string')
      .map((item) => normalizeAwb(item))
      .filter((item) => item);

    return Array.from(new Set(normalized)).slice(0, limit);
  } catch {
    return [];
  }
};

export const saveRecentAwbs = (storageKey: string, awbs: string[]): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(awbs));
  } catch {
    // Ignore storage write failures (private mode, quota, etc.)
  }
};

export const buildRecentAwbList = (
  current: string[],
  awb: string,
  limit: number = DEFAULT_RECENT_AWB_LIMIT
): string[] => {
  const normalized = normalizeAwb(awb);
  if (!normalized) return current.slice(0, limit);
  const next = [normalized, ...current.filter((item) => item !== normalized)];
  return next.slice(0, limit);
};

export const clearRecentAwbs = (storageKey: string): void => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(storageKey);
  } catch {
    // Ignore storage removal failures (private mode, quota, etc.)
  }
};
